import Vue from "vue"
import VueRouter from "vue-router"
import TheLayout from "@/containers/TheLayout.vue"
import store from "../store"

Vue.use(VueRouter)

const routes = [
  {
    path: "*",
    name: "page-not-found",
    component: () => import(/* webpackChunkName: "404" */ "@/views/404/404.vue")
  },
  {
    path: "/",
    component: TheLayout,
    children: [
      {
        path: "",
        name: "Dashboard",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "Dashboard" */ "../views/Dashboard/Dashboard.vue"
          )
      },
      {
        path: "/voucher",
        name: "Voucher Management",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "Voucher" */ "../views/Voucher/Voucher.vue"
          )
      },
      {
        path: "/voucher/create",
        name: "Create Voucher",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "CreateVoucher" */ "../views/Voucher/CreateVoucher.vue"
          )
      },
      {
        path: "/voucher/:id",
        name: "Edit Voucher",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "EditBanner" */ "../views/Voucher/UpdateVoucher.vue"
          )
      },
      {
        path: "/banner",
        name: "Banner Management",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "BannerList" */ "../views/Banner/BannerList.vue"
          )
      },
      {
        path: "/banner/create",
        name: "Create Banner",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "CreateBanner" */ "../views/Banner/BannerFormCreate.vue"
          )
      },
      {
        path: "/banner/edit/:id",
        name: "Edit Banner",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "EditBanner" */ "../views/Banner/BannerFormUpdate.vue"
          )
      },
      {
        path: "/partner",
        name: "Partner Logistik",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "Partner" */ "../views/Internal/Partner/Partner.vue"
          )
      },
      {
        path: "/partner/create",
        name: "Create Partner Logistik",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "CreatePartner" */ "../views/Internal/Partner/CreatePartner.vue"
          )
      },
      {
        path: "/partner/detail/:id",
        name: "Partner Logistik Detail",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "PartnerDetail" */ "../views/Internal/Partner/PartnerDetail.vue"
          )
      },
      {
        path: "/partner-self-registration",
        name: "Partner Logistik Self Registration",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "PartnerDetail" */ "../views/Internal/Partner/PartnerSelfRegistration.vue"
          )
      },
      {
        path: "/merchant",
        name: "Business Merchant",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "BusinessMerchant" */ "../views/Internal/Business/Merchant.vue"
          )
      },
      {
        path: "/merchant/create",
        name: "Create Business Merchant",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "CreateBusinessMerchant" */ "../views/Internal/Business/CreateMerchant.vue"
          )
      },
      {
        path: "/merchant/detail/:id",
        name: "Business Merchant Detail",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "MerchantDetail" */ "../views/Internal/Business/MerchantDetail.vue"
          )
      },
      {
        path: "/self-registration",
        name: "Self Registration",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "BusinessMerchant" */ "../views/Internal/Business/SelfRegistration.vue"
          )
      },
      {
        path: "/order",
        name: "Order",
        meta: {
          submenu: false
        },
        component: () =>
          import(/* webpackChunkName: "Order" */ "../views/Order/Order.vue")
      },
      {
        path: "/order/instant-deliveries",
        name: "Instant Delivery",
        meta: { title: "Instant Delivery - Linknau" },
        component: () =>
          import(/* webpackChunkName: "InstantDelivery" */ "../views/Order/InstantDelivery.vue")
      },
      {
        path: "/order/detail/:id",
        name: "Order Detail",
        component: () =>
          import(
            /* webpackChunkName: "OrderDetail" */ "../views/Order/OrderDetail.vue"
          )
      },
      {
        path: "/order/create",
        name: "Create Order",
        component: () =>
          import(
            /* webpackChunkName: "CreateOrder" */ "../views/Order/CreateOrder.vue"
          )
      },
      {
        path: "/order/pickup",
        name: "Order Pickup",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "RequestPickup" */ "../views/Order/RequestPickup.vue"
          )
      },
      {
        path: "/order/pickup/detail/:id",
        name: "Order Pickup Detail",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "RequestPickupDetail" */ "../views/Order/RequestPickupDetail.vue"
          )
      },
      {
        path: "/order/insufficient-payment",
        name: "Order Insufficient Payment",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "InsufficientPayment" */ "../views/Order/InsufficientPayment.vue"
          )
      },
      {
        path: "/order/insufficient-payment/:id",
        name: "Order Insufficient Payment Detail",
        component: () =>
          import(
            /* webpackChunkName: "InsufficientPaymentDetail" */ "../views/Order/InsufficientPaymentDetail.vue"
          )
      },
      {
        path: "/order/price-adjustment",
        name: "Price Adjustment",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "PriceAdjustment" */ "../views/Order/PriceAdjustment.vue"
          )
      },
      {
        path: "/armada/partner",
        name: "Partner",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "Partner" */ "../views/Partner/Partner.vue"
          )
      },
      {
        path: "/armada/partner/detail/:id",
        name: "Partner Detail",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "PartnerDetail" */ "../views/Partner/PartnerDetail.vue"
          )
      },
      {
        path: "/armada/partner/create",
        name: "Create Partner",
        component: () =>
          import(
            /* webpackChunkName: "CreatePartner" */ "../views/Partner/CreatePartner.vue"
          ),
        meta: {
          submenu: true
        }
      },
      {
        path: "/armada/partner/edit/:id",
        name: "Edit Partner",
        component: () =>
          import(
            /* webpackChunkName: "EditPartner" */ "../views/Partner/EditPartner.vue"
          ),
        meta: {
          submenu: true
        }
      },
      {
        path: "/tracking",
        name: "Tracking",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "Tracking" */ "../views/Tracking/Tracking.vue"
          )
      },
      {
        path: "/tracking/:id",
        name: "Tracking Detail",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "TrackingDetail" */ "../views/Tracking/TrackingDetail.vue"
          )
      },
      {
        path: "/reports",
        name: "Reports",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "Reports" */ "../views/Income/Reports.vue"
          )
      },
      {
        path: "/user",
        name: "User",
        meta: {
          submenu: true
        },
        component: () =>
          import(/* webpackChunkName: "User" */ "../views/User/User.vue")
      },
      {
        path: "/user/create",
        name: "Create User",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "CreateUser" */ "../views/User/CreateUser.vue"
          )
      },
      {
        path: "/user/detail/:id",
        name: "User Detail",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "UserDetail" */ "../views/User/UserDetail.vue"
          )
      },
      {
        path: "/hub",
        name: "Hub",
        component: () =>
          import(/* webpackChunkName: "Hub" */ "../views/Hub/Hub.vue")
      },
      {
        path: "/hub/create",
        name: "CreateHub",
        component: () =>
          import(
            /* webpackChunkName: "CreateHub" */ "../views/Hub/CreateHub.vue"
          )
      },
      {
        path: "/hub/detail/:id",
        name: "Hub Detail",
        component: () =>
          import(
            /* webpackChunkName: "HubDetail" */ "../views/Hub/HubDetail.vue"
          )
      },
      {
        path: "/finance/income",
        name: "Income",
        component: () =>
          import(/* webpackChunkName: "Income" */ "../views/Income/Income.vue"),
        meta: {
          submenu: true
        }
      },
      {
        path: "/finance/withdraw",
        name: "Withdraw",
        component: () =>
          import(
            /* webpackChunkName: "Withdraw" */ "../views/Withdraw/Withdraw.vue"
          ),
        meta: {
          submenu: true
        }
      },
      {
        path: "/package",
        name: "Package",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "Package" */ "../views/Package/Package.vue"
          )
      },
      {
        path: "/package/create",
        name: "Create Package",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "CreatePackage" */ "../views/Package/CreatePackage.vue"
          )
      },
      {
        path: "/package/detail/:id",
        name: "Package Detail",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "PackageDetail" */ "../views/Package/PackageDetail.vue"
          )
      },
      {
        path: "/package/update/:id",
        name: "Update Package",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "UpdatePackage" */ "../views/Package/CreatePackage.vue"
          )
      },
      {
        path: "/package/cost-mapping",
        name: "Cost Mapping",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "CostMapping" */ "../views/Package/CostMapping.vue"
          )
      },
      {
        path: "/package/cost-mapping/detail/:id",
        name: "Cost Mapping Detail",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "CostMappingDetail" */ "../views/Package/CostMappingDetail.vue"
          )
      },
      {
        path: "/package/cost-mapping/detail/:id/update",
        name: "Cost Mapping Detail Update",
        meta: {
          submenu: true,
          mode: "edit"
        },
        component: () =>
          import(
            /* webpackChunkName: "CostMappingDetail" */ "../views/Package/CostMappingDetail.vue"
          )
      },
      {
        path: "/package/cost-mapping/detail/:id/duplicate",
        name: "Cost Mapping Duplicate",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "CostMappingDetail" */ "../views/Package/CreateCostMapping.vue"
          )
      },
      {
        path: "/package/cost-mapping/create",
        name: "Create Cost Mapping",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "CreateCostMapping" */ "../views/Package/CreateCostMapping.vue"
          )
      },
      {
        path: "/goods-category",
        name: "Goods Category",
        component: () =>
          import(
            /* webpackChunkName: "GoodsCategory" */ "../views/GoodsCategory/GoodsCategory.vue"
          )
      },
      {
        path: "/goods-category/create",
        name: "Create Goods Category",
        component: () =>
          import(
            /* webpackChunkName: "GoodsCategory" */ "../views/GoodsCategory/CreateGoodsCategory.vue"
          )
      },
      {
        path: "/goods-category/detail/:id",
        name: "Goods Category Detail",
        component: () =>
          import(
            /* webpackChunkName: "GoodsCategoryDetail" */ "../views/GoodsCategory/GoodsCategoryDetail.vue"
          )
      },
      {
        path: "/role/role-management",
        name: "Role Management",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "User-Role" */ "../views/User/RoleManagement.vue"
          )
      },
      {
        path: "/role/permission",
        name: "Permission List",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "Permission" */ "../views/User/Permission.vue"
          )
      },
      {
        path: "/user/role",
        name: "Role List",
        meta: {
          submenu: true
        },
        component: () =>
          import(/* webpackChunkName: "Role" */ "../views/User/Role.vue")
      },
      {
        path: "/user/role/detail/:id",
        name: "Role Detail",
        component: () =>
          import(
            /* webpackChunkName: "role-detail" */ "../views/User/RoleDetail.vue"
          )
      },
      {
        path: "/role/create",
        name: "Create Role",
        component: () =>
          import(
            /* webpackChunkName: "create-role" */ "../views/User/CreateRole.vue"
          )
      },
      {
        path: "/master-data/city",
        name: "Master Data City",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "MasterDataCity" */ "../views/Master/City.vue"
          )
      },
      {
        path: "/master-data/payment-method",
        name: "Master Data Payment Method",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "MasterDataPaymentMethod" */ "../views/Master/PaymentMethod.vue"
          )
      },
      {
        path: "/master-data/goods-category",
        name: "Master Data Goods Category",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "MasterDataGoodsCategory" */ "../views/Master/GoodsCategory.vue"
          )
      },
      {
        path: "/master-data/bank-code",
        name: "Master Data Bank Code",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "MasterDataBankCode" */ "../views/Master/BankCode.vue"
          )
      },
      {
        path: "/admin",
        name: "Admin List",
        component: () =>
          import(
            /* webpackChunkName: "AdminList" */ "../views/Admin/AdminList.vue"
          )
      },
      {
        path: "/admin/detail/:id",
        name: "Admin Detail",
        component: () =>
          import(
            /* webpackChunkName: "AdminDetail" */ "../views/Admin/AdminDetail.vue"
          )
      },
      {
        path: "/admin/create",
        name: "Create Admin",
        component: () =>
          import(
            /* webpackChunkName: "CreateAdmin" */ "../views/Admin/CreateAdmin.vue"
          )
      },
      // {
      //   path: '/delivery/package',
      //   name: 'Package',
      //   component: () => import(/* webpackChunkName: "PackageList" */ '../views/Delivery/Package.vue')
      // },
      // {
      //   path: '/delivery/package/create',
      //   name: 'Create Package',
      //   component: () => import(/* webpackChunkName: "CreatePackage" */ '../views/Delivery/CreatePackage.vue')
      // },
      // {
      //   path: '/delivery/package/detail/:id',
      //   name: 'Package Detail',
      //   component: () => import(/* webpackChunkName: "PackageDetail" */ '../views/Delivery/PackageDetail.vue')
      // },
      {
        path: "/profile",
        name: "Profile",
        component: () =>
          import(
            /* webpackChunkName: "PackageDetail" */ "../views/Profile/Profile.vue"
          )
      },
      {
        path: "/armada",
        name: "Armada",
        component: () =>
          import(/* webpackChunkName: "Armada" */ "../views/Armada/Armada.vue"),
        meta: {
          submenu: true
        }
      },
      {
        path: "/armada/create",
        name: "Create Armada",
        component: () =>
          import(
            /* webpackChunkName: "CreateArmada" */ "../views/Armada/CreateArmada.vue"
          ),
        meta: {
          submenu: true
        }
      },
      {
        path: "/armada/detail/:id",
        name: "Armada Detail",
        component: () =>
          import(
            /* webpackChunkName: "ArmadaDetail" */ "../views/Armada/ArmadaDetail.vue"
          ),
        meta: {
          submenu: true
        }
      },
      {
        path: "/kurir",
        name: "Courier",
        component: () =>
          import(
            /* webpackChunkName: "Courier" */ "../views/Courier/Courier.vue"
          )
      },
      {
        path: "/kurir/create",
        name: "Create Courier",
        component: () =>
          import(
            /* webpackChunkName: "CreateCourier" */ "../views/Courier/CreateCourier.vue"
          )
      },
      {
        path: "/kurir/detail/:id",
        name: "Courier Detail",
        component: () =>
          import(
            /* webpackChunkName: "CourierDetail" */ "../views/Courier/CourierDetail.vue"
          )
      },
      {
        path: "/web-settings/mitra-logos",
        name: "Partner Logos",
        component: () =>
          import(
            /* webpackChunkName: "CourierDetail" */ "../views/WebSettings/MitraLogos.vue"
          )
      },
      {
        path: "/invoice",
        name: "Invoice",
        component: () =>
          import(/* webpackChunkName: "Login" */ "../views/Invoice/Invoice.vue")
      },
      {
        path: "/invoice/detail/:id",
        name: "Invoice Detail",
        component: () =>
          import(
            /* webpackChunkName: "Login" */ "../views/Invoice/InvoiceDetail.vue"
          )
      },
      {
        path: "/invoices/customers",
        name: "Invoices - Customers",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "InvoicesCustomers" */ "../views/Invoices/Customers.vue"
          )
      },
      {
        path: "/invoices/resi",
        name: "Invoices - Resi",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "InvoicesResi" */ "../views/Invoices/Resi.vue"
          )
      },
      {
        path: "/invoices/resi/:id",
        name: "Invoices - Resi Detail",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "InvoicesResiDetail" */ "../views/Invoices/ResiDetail.vue"
          )
      },
      {
        path: "/invoices/invoices",
        name: "Invoices - Invoices",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "InvoicesInvoices" */ "../views/Invoices/Invoices.vue"
          )
      },
      {
        path: "/invoices/invoices/:id",
        name: "Invoices - Invoice Detail",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "InvoicesInvoiceDetail" */ "../views/Invoices/InvoiceDetail.vue"
          )
      },
      {
        path: "/notifikasi",
        name: "Notifikasi",
        component: () =>
          import(
            /* webpackChunkName: "Login" */ "../views/Notification/Notification.vue"
          )
      },
      {
        path: "/article",
        name: "Article",
        component: () =>
          import(
            /* webpackChunkName: "Article" */ "../views/Article/ArticleList.vue"
          )
      },
      {
        path: "/article/create",
        name: "Create Article",
        component: () =>
          import(
            /* webpackChunkName: "create-article" */ "../views/Article/ArticleFormCreate.vue"
          )
      },
      {
        path: "/article/:id",
        name: "Article Detail",
        component: () =>
          import(
            /* webpackChunkName: "article-detail" */ "../views/Article/ArticleFormUpdate.vue"
          )
      },
      {
        path: "/career",
        name: "Career",
        component: () =>
          import(
            /* webpackChunkName: "Career" */ "../views/Career/CareerList.vue"
          )
      },
      {
        path: "/career/create",
        name: "Create Career",
        component: () =>
          import(
            /* webpackChunkName: "create-career" */ "../views/Career/CareerFormCreate.vue"
          )
      },
      {
        path: "/career/detail/:id",
        name: "Career Detail & Submissions",
        component: () =>
          import(
            /* webpackChunkName: "career-detail-submissions" */ "../views/Career/CareerDetail.vue"
          )
      },
      {
        path: "/career/:id",
        name: "Edit Career",
        component: () =>
          import(
            /* webpackChunkName: "career-edit" */ "../views/Career/CareerFormUpdate.vue"
          )
      },
      {
        path: "/promo",
        name: "Promo Management",
        meta: {
          submenu: false
        },
        component: () =>
          import(/* webpackChunkName: "Promo" */ "../views/Promo/Promo.vue")
      },
      {
        path: "/promo/create",
        name: "Create Promo",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "CreatePromo" */ "../views/Promo/CreatePromo.vue"
          )
      },
      {
        path: "/promo/edit/:id",
        name: "Edit Promo",
        meta: {
          submenu: false
        },
        component: () =>
          import(
            /* webpackChunkName: "EditPromo" */ "../views/Promo/CreatePromo.vue"
          )
      },
      {
        path: "/smesco/fee-setting",
        name: "Smesco Fee Setting",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "Smesco" */ "../views/Smesco/FeeSetting/List.vue"
          )
      },
      {
        path: "/smesco/fee-setting/create",
        name: "Create Smesco Fee Setting",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "Smesco" */ "../views/Smesco/FeeSetting/Form.vue"
          )
      },
      {
        path: "/smesco/fee-setting/edit/:id",
        name: "Edit Smesco Fee Setting",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "Smesco" */ "../views/Smesco/FeeSetting/Form.vue"
          )
      },
      {
        path: "/smesco/revenue",
        name: "Smesco Revenue",
        meta: {
          submenu: true
        },
        component: () =>
          import(
            /* webpackChunkName: "Smesco" */ "../views/Smesco/Revenue/Index.vue"
          )
      },
      {
        path: "/request-demo",
        name: "Request Demo",
        component: () =>
          import(
            /* webpackChunkName: "RequestDemo" */ "../views/RequestDemo/List.vue"
          )
      }
    ]
  },
  {
    path: "/login",
    name: "Login",
    component: () =>
      import(/* webpackChunkName: "Login" */ "../views/Login/Login.vue")
  },
  {
    path: "/reset-password",
    name: "Reset Password",
    component: () =>
      import(/* webpackChunkName: "Login" */ "../views/Login/ResetPassword.vue")
  }
]

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
})

router.beforeEach((to, from, next) => {
  store.dispatch("auth/getCurrentUser")
  const tokenExpire = store.getters["auth/userData"]?.token?.expired_at
  if (new Date().getTime() > new Date(tokenExpire).getTime()) {
    store.dispatch("auth/removeUserData")
    next({
      name: "Login"
    })
    return
  }
  if (!store.getters["auth/isLoggedIn"] && to.name !== "Login") {
    next({
      name: "Login"
    })
    return
  }
  if (store.getters["auth/isLoggedIn"] && to.name === "Login") {
    next({
      name: "Order"
    })
    return
  }
  if (
    store.getters["auth/isLoggedIn"] &&
    to.name !== "Reset Password" &&
    store.getters["auth/userData"]?.user?.require_change_password
  ) {
    next({
      name: "Reset Password"
    })
    return
  }
  if (
    store.getters["auth/isLoggedIn"] &&
    to.name === "Reset Password" &&
    !store.getters["auth/userData"]?.user?.require_change_password
  ) {
    next({
      name: "Order"
    })
    return
  }
  next()
})

router.afterEach((to, from) => {
  if (store.getters["common/isMobile"]) {
    store.dispatch("common/expandMenu", true)
  }
})

export default router
